import React, { children } from "react";

const Btn = ({ type = "", onClick = () => {}, children }) => {
  const renderType = () => {
    switch (type) {
      case "filteringBtn":
        return {
          height: "40px",
          width: "100%",
          background: "#0099FF",
          padding: "7px  22px",
          color: "white",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        };
      case "categoriesBtn":
        return {
          height: "49px",
          background: "rgba(0,153,255,0.7)",
          padding: "5px 8px 9px 8px",
          color: "white",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "auto",
        };
      case "steperBtn":
        return {
          height: "40px",
          padding: "12px",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        };
      case "check":
        return {
          height: "30px",
          padding: "12px",
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        };

      default:
        break;
    }
  };
  return (
    <button
      style={{
        borderRadius: "15px",
        backgroundColor: "transparent",
        width: "100%",
        border: "none",
        background: "#0099FF",
        color: "white",
        padding: "5px",
        whiteSpace: "nowrap",
        ...renderType(),
      }}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Btn;
